export default {
    name: "baggage-component",

    data() {
        return {
            baggage_services: [],
            updated_row: [],
        }
    },

    mounted() {

    },

    created() {
        this.$api.get('baggage.index')
            .then(response => {
                this.baggage_services = response.data;
            });
    },

    methods: {
        deleteItem(item) {
            let indx = this.baggage_services.indexOf(item);
            if (indx > -1 && confirm(this.i18n('Do you really want to delete?'))) {
                this.$api.delete('baggage.delete', item.id)
                    .then(res => {
                        if (!res.errors) {
                            this.baggage_services.splice(indx, 1);
                            this.$store.commit('successNotify');
                        }
                    })
            }
        },
        updateRow() {
            console.log('somethiung');
        },
    },

}
